// Module
var code = `<div appHeaderBar>
    <header-bar-title>Card Details</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <form name="CheckingAccountAdd"
          id="CheckingAccountAdd"
          tid="CheckingAccountAdd"
          #checkingAccountAdd="ngForm"
          *ngIf="doneLoading">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <h1 class="HOA-container__header-text"
                    tid="accountNickname" >
                    <span>{{paymentMethod.nickname}}</span>
                    <span>({{paymentMethod.maskedId}})</span>
                </h1>
            </div>
            <div class="HOA-container__content">
                <div class="HOA-flextable-component__subheader u-mT3 u-mB7" tid="secondaryHeader">
                    Card Details
                    <button type="button"
                            id="secondaryEdit"
                            tid="secondaryEdit"
                            class="Button Button--link"
                            [routerLink]="['/wallet/editcarddetails', paymentMethod.id]"
                            [state]="{paymentMethodId: paymentMethod.id}">
                        Edit
                    </button>
                </div>
                <div class="HOA-flextable-component HOA-flextable-component__form HOA-Has-Default-Switch">
                    <div class="Field HOA-flextable-component__cell-input HOA-sm-order-2 HOA-lg-order-1">
                        <label class="Field-label" tid="nameOnCardLabel">Name on Card</label>
                        <div class="u-pH4">
                            <span tid="nameOnCard">{{paymentMethod.cardHolderName}}</span>
                        </div>
                    </div>
                    <div *ngIf="paymentMethod.defaultMethod" class="Field u-pH4 HOA-sm-order-1 HOA-lg-order-2">
                        <div class="HOA-Toggle-Align HOA-flex-component">
                                    <span class="Icon Icon--18 u-iconBlue" tid="checkingDefaultRadioButton">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                             width="18"
                                             height="18"
                                             viewBox="0 0 72 72">
                                            <title>Default Payment</title>
                                            <path class="stroke_layer fill_layer"
                                                  fill="#082538"
                                                  stroke="#082538"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="4.6"
                                                  d="M36.3 9l6.3 20.6h20.7L46.6 42.4 52.9 63 36.3 50.3 19.6 63l6.3-20.6L9.3 29.6h20.6L36.3 9z">
                                            </path>
                                        </svg>
                                    </span>
                            <span class="u-pL2 Toggle-label">Default Payment</span>
                        </div>
                    </div>
                </div>
                <div class="HOA-flextable-component HOA-flextable-component__form">
                    <div class="Field HOA-flextable-component__cell-input">
                        <label class="Field-label" tid="accountNumberLabel">Card Number</label>
                        <div class="u-pH4">
                            <span tid="accountNumber">xxxx xxxx xxxx {{paymentMethod.maskedId}}</span>
                        </div>
                    </div>
                    <div class="Field HOA-flextable-component__cell-input">
                        <label class="Field-label" tid="expirationDateLabel">Expiration Date</label>
                        <div class="u-pH4">
                            <span tid="expirationDate">
                                {{paymentMethod.expirationMonth}}/{{paymentMethod.expirationYear}}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="HOA-flextable-component HOA-flextable-component__form">
                    <div class="Field HOA-flextable-component__cell-input">
                        <label class="Field-label" tid="billingAddressLabel">Card Billing Address</label>
                        <div class="u-pH4">
                            <span tid="address1">{{paymentMethod.line1}}</span>
                            <span tid="addressUnit">{{paymentMethod.unit}}</span>
                        </div>
                        <div class="u-pH4" *ngIf="paymentMethod.line2">
                            <span tid="address2">{{paymentMethod.line2}}</span>
                        </div>
                        <div class="u-pH4">
                            <span tid="addressCity">{{paymentMethod.city}}</span>,
                            <span tid="addressState">{{paymentMethod.state}}</span>
                            <span tid="addressZip">{{paymentMethod.zipcode}}</span>
                        </div>
                        <div class="u-pH4">
                            <span tid="addressCountry">{{paymentMethod.country}}</span>
                        </div>
                    </div>
                    <div class="HOA-flextable-component__cell--50">
                    </div>
                </div>
                <div class="HOA-container__content-hrule
                                    HOA-propertyblock-flextable__cell
                                    HOA-propertyblock-flextable__cell--100
                                    u-mT5">
                </div>
                <div class="HOA-flextable-component__subheader u-mT3 u-mB7" tid="schedulePaymentsHeader">
                    Scheduled Payments
                </div>

                <app-payment-schedule *ngIf="true"
                                      [paymentSchedules]="paymentSchedules"
                                      [isPaymentMethodView]="true">
                </app-payment-schedule>

                <div class="u-pT5 HOA-Checking-Detail-button-container">
                    <button name="cancel"
                            id="back"
                            tid="back"
                            type="button"
                            class="Button Button--link "
                            (click)="cancel()">
                        Back
                    </button>
                </div>
            </div>
        </div>
    </form>
    <div class="HOA-remove-button-container">
        <button name="submitDelete"
                id="submitDelete"
                tid="submitDelete"
                type="submit"
                class="Button Button--outline"
                (click)="removeCard()">
            Delete Payment Method
        </button>
    </div>
</app-page-content>`;
// Exports
module.exports = code;